<div
  class="pin-marker"
  [ngClass]="{
    'pin-iconic': isIconic(),
    'pin-primary': color() === 'primary' && !isIconic(),
    'pin-secondary': color() === 'secondary' && !isIconic(),
    'pin-tertiary': color() === 'tertiary' && !isIconic()
  }"
  [class.clickable]="clickable()"
  [style]="{ scale: size() }"
  (click)="onClick($event)"
  (blur)="onBlur()"
  matRipple
  [matRippleDisabled]="!clickable()"
>
  <div class="mat-label-large">
    @if(icons()) { @for(icon of icons()!; track icon) {
    <mat-icon style="height: 20px; font-size: 20px; width: 20px">
      {{ icon }}
    </mat-icon>
    } } @if(number()) {
    <span class>{{ number() }}</span>
    } @if(isExpanded()) {
    <div class="expanded-content">
      <span class="mat-label-medium">Hello</span>
    </div>
    }
  </div>
  <svg
    width="18"
    height="12"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.88614 10.6061C7.4508 11.2455 7.73313 11.5653 8.04116 11.7336C8.63871 12.06 9.36129 12.06 9.95884 11.7336C10.2669 11.5653 10.5492 11.2455 11.1139 10.6061L16.1201 4.93655C17.1337 3.78859 17.6406 3.21461 17.7605 2.75071C17.9955 1.84214 17.5671 0.8924 16.7305 0.467134C16.3034 0.25 15.5377 0.25 14.0062 0.25H3.99378C2.46234 0.25 1.69663 0.25 1.26948 0.467134C0.432911 0.8924 0.00453424 1.84214 0.239482 2.75071C0.359444 3.21461 0.86627 3.78859 1.87992 4.93655L6.88614 10.6061Z"
    />
  </svg>
</div>
